import { Component, lazy, Suspense, useEffect, useState, type ReactNode } from "react"

import { useKeybindings } from "@/hooks/useKeybindings"

const Agentation = lazy(() =>
  import("agentation").then((module) => ({ default: module.Agentation })),
)

// An optional annotation tool must never replace the application if its chunk fails.
class AnnotationErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  override render() {
    return this.state.failed ? null : this.props.children
  }
}

export function Annotations() {
  const [visible, setVisible] = useState(false)

  useKeybindings({
    ".": (event) => {
      if (event.defaultPrevented || event.repeat || event.isComposing) return
      event.preventDefault()
      setVisible((current) => !current)
    },
  })

  if (!visible) return null

  return (
    <AnnotationErrorBoundary>
      <Suspense fallback={null}>
        <ExpandedAgentation />
      </Suspense>
    </AnnotationErrorBoundary>
  )
}

function ExpandedAgentation() {
  useEffect(() => {
    // Agentation 3 has no initial-open prop and mounts its portal after an effect.
    const expand = () => {
      const toggle = document.querySelector<HTMLElement>(
        '[data-agentation-toolbar] [title="Start feedback mode"]',
      )
      if (!toggle) return
      observer.disconnect()
      toggle.click()
    }
    const observer = new MutationObserver(expand)
    observer.observe(document.body, { childList: true, subtree: true })
    expand()
    return () => observer.disconnect()
  }, [])

  return <Agentation />
}
